import {AuthAPI} from "../../api/api";

const SET_LOGIN = 'loginReducer/SET_LOGIN';
const SET_PASSWORD = 'loginReducer/SET_PASSWORD';
const REMEMBER_ME_SWITCH = 'loginReducer/REMEMBER_ME_SWITCH';
const SET_LOGGED_IN = 'loginReducer/SET_LOGGED_IN';
const SET_ERROR = 'loginReducer/SET_ERROR';
const SET_FORWARDING_PATH = 'loginReducer/SET_FORWARDING_PATH'
const SET_FORWARDING_PATH_QR = 'loginReducer/SET_FORWARDING_PATH_QR'
const SET_CLEARE_PATH = 'loginReducer/SET_CLEARE_PATH'


const initialState = {
    login: '',
    password: '',
    rememberMe: false,
    isLoggedIn: false,
    error: null,
    forwardingPath: '/',
    forwardingPathQr: '',
}

export const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOGIN:
            return {
                ...state,
                login: action.login
            }
        case SET_PASSWORD:
            return {
                ...state,
                password: action.password
            }
        case REMEMBER_ME_SWITCH:
            return {
                ...state,
                rememberMe: !state.rememberMe
            }
        case SET_LOGGED_IN:
            return {
                ...state,
                isLoggedIn: action.isLoggedIn
            }

        case SET_ERROR:
            return {
                ...state,
                error: action.error
            }
        case SET_FORWARDING_PATH:
            return {
                ...state,
                forwardingPath: action.path
            }
        case SET_FORWARDING_PATH_QR:
            return {
                ...state,
                forwardingPathQr: action.path
            }
        case SET_CLEARE_PATH:
            return {
                ...state,
                forwardingPath: '/',
                forwardingPathQr: '',
            }
        default:
            return state;
    }
}

export const getLogin = state => state.loginReducer.login
export const getPassword = state => state.loginReducer.password
export const getRememberMe = state => state.loginReducer.rememberMe
export const getLoggedIn = state => state.loginReducer.isLoggedIn
export const getError = state => state.loginReducer.error
export const forwardingPath = state => state.loginReducer.forwardingPath
export const forwardingPathQr = state => state.loginReducer.forwardingPathQr

export const setLogin = (login) => ({type: SET_LOGIN, login})
export const setPassword = (password) => ({type: SET_PASSWORD, password})
export const rememberMeSwitch = () => ({type: REMEMBER_ME_SWITCH})
export const setLoggedIn = (isLoggedIn) => ({type: SET_LOGGED_IN, isLoggedIn})
export const setError = (error) => ({type: SET_ERROR, error})
export const setForwardingPath = (path) => ({type: SET_FORWARDING_PATH, path})
export const setForwardingPathQr = (path) => ({type: SET_FORWARDING_PATH_QR, path})
export const cleareForwadingPath = () => ({type: SET_CLEARE_PATH})

export const authorization = (username, password) => async dispatch => {
    try {
        if (!username || !password) {
            let error = {}
            if (!username) {
                error = {...error, login: {text: 'Введите логин'}}
            }
            if (!password) {
                error = {...error, password: {text: 'Введите пароль'}}
            }
            dispatch(setError(error))
        }

        const response = await AuthAPI.login(username, password)
        if (response.status === 200 && response.statusText === 'OK') {
            dispatch(setLogin(''))
            dispatch(setPassword(''))
            dispatch(setLoggedIn(true))
            dispatch(setError(null))
        } else {
            dispatch(setPassword(''))
        }
    } catch (error) {
        if (error?.response?.data?.detail === 'No active account found with the given credentials') {
            dispatch(setError({password: {text: 'Неверное имя пользователя или пароль'}}))
        }
    }

}

export const logout = () => async (dispatch) => {
    try {
        await AuthAPI.logout()
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')        
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('persist:appState');

    } finally {
        dispatch(clearCredentials())
    }
}

export const clearCredentials = () => async (dispatch) => {
    clearCredentials()
    dispatch(setLoggedIn(false));
}